import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BrandsForInvestmentModal } from '@/modals/BrandsForInvestmentModal';
import { Badge, Button, MyTooltip } from '@scramble/ui';
import { useElementObserver } from '@/helpers/useElementObserver';
import { useBrandSelectionStatus } from '../../../hooks/useBrandSelectionStatus';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import Analytics from '@/analyticsGA';
import s from './index.module.scss';

export const BrandSelection = ({ wizardId }) => {
  const { t } = useTranslation();
  const {
    data,
    selectedAndUnFilledBrandCount,
    newBrands,
    excludedBrands,
    fee,
    hasData,
  } = useBrandSelectionStatus();
  const { openSingleModal } = useModal();
  useElementObserver({
    element: "[data-observer='brand-selection']",
    percent: 100,
    once: true,
    onDetect: () =>
      hasData &&
      Analytics.investingWizardStep1Bfi({
        wizard_id: wizardId,
        new_brands_exist: !!newBrands,
        new_brands_count: newBrands,
      }),
  });

  const onEdit = () => {
    openSingleModal(MODAL_IDS.brands_for_investment);
  };

  if (!hasData) return null;

  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        {t('investing:brand_selection.investment_options')}
      </div>
      <div className={s.block} data-observer="brand-selection">
        <div className={s.left}>
          <div className={s.block_header}>
            <span className={s.block_title}>
              {t('investing:brand_selection.brands_for_investment')}
            </span>
            {!!newBrands && (
              <MyTooltip
                renderContent={() => (
                  <div className={classnames(s.tooltip_new, 'f-body-sm')}>
                    {t('investing:brand_selection.tooltip_new_brands', {
                      count: newBrands,
                    })}
                  </div>
                )}
                renderElement={() => (
                  <Badge
                    type="success"
                    appearance="filled"
                    size="small"
                    onMouseOver={() =>
                      Analytics.investingWizardStep1TtnShow({
                        wizard_id: wizardId,
                      })
                    }
                    label={t('investing:brand_selection.new_brands', {
                      count: newBrands,
                    })}
                  />
                )}
              />
            )}
          </div>
          <div className={s.block_desc}>
            {excludedBrands > 0
              ? t('investing:brand_selection.changed_composition', {
                  fee: data?.fee ?? fee,
                })
              : newBrands > 0
                ? t('investing:brand_selection.new_brands_available')
                : t('investing:brand_selection.exclude_brands', {
                    fee: data?.fee ?? fee,
                  })}
          </div>
        </div>
        <div className={s.right}>
          <div className={s.block_included}>
            {t('investing:brand_selection.brands_included', {
              count: selectedAndUnFilledBrandCount,
            })}
          </div>
          <Button
            theme="neutral"
            appearance="filled"
            size="md"
            className={s.btn_edit}
            onClick={onEdit}
          >
            {t('investing:brand_selection.edit')}
          </Button>
        </div>
        <BrandsForInvestmentModal wizardId={wizardId} />
      </div>
    </div>
  );
};
